import React from 'react';
import { 
  BrowserRouter as Router, 
  Routes, 
  Route, 
  Navigate,
  createBrowserRouter,
  RouterProvider 
} from 'react-router-dom';
import { AuthProvider, useAuth } from './hooks/useAuth';
import Layout from './components/Layout';

// Импорты страниц
import Login from './pages/Login/Login';
import Dashboard from './pages/Dashboard/Dashboard';
import Shifts from './pages/Shifts/Shifts';
import Tasks from './pages/Tasks/Tasks';
import Wiki from './pages/Wiki/Wiki';
import Users from './pages/Users/Users';
import ShiftRequests from './pages/ShiftRequests/ShiftRequests';

import './App.css';

// Компонент для проверки аутентификации
function ProtectedRoute({ children, adminOnly = false }) {
  const { user, loading, isAdmin } = useAuth();
  
  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        fontSize: '18px'
      }}>
        <div>Загрузка...</div>
      </div>
    );
  }
  
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  
  if (adminOnly && !isAdmin()) {
    return <Navigate to="/shifts" replace />;
  }
  
  return children;
}

// Основной компонент маршрутизации
function AppRoutes() {
  const { user } = useAuth();
  
  return (
    <Routes>
      {/* Публичный маршрут */}
      <Route path="/login" element={<Login />} />
      
      {/* Защищенные маршруты с Layout и Outlet */}
      <Route 
        path="/*" 
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        } 
      >
        {/* Вложенные маршруты которые рендерятся в Outlet */}
        <Route index element={<Navigate to="/shifts" replace />} />
        <Route path="shifts" element={<Shifts />} />
        <Route path="tasks" element={<Tasks />} />
        <Route path="wiki" element={<Wiki />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="users" element={<Users />} />
        <Route path="shift-requests" element={<ShiftRequests />} />
        <Route path="*" element={<Navigate to="/shifts" replace />} />
      </Route>
      
      {/* Редирект для корневого пути */}
      <Route 
        path="/" 
        element={
          <Navigate to={user ? "/shifts" : "/login"} replace />
        } 
      />
    </Routes>
  );
}

// Создаем router с future flags
const router = createBrowserRouter([
  {
    path: "/*",
    element: <AppRoutes />
  }
], {
  future: {
    v7_startTransition: true,
    v7_relativeSplatPath: true,
  }
});

// Главный компонент приложения
function App() {
  return (
    <AuthProvider>
      <RouterProvider router={router} />
    </AuthProvider>
  );
}

export default App;